import { el, fmtDate } from '../lib/dom.js';
import { badge } from '../lib/ui.js';

// ---------------------------------------------------------------------------
// Renders one AdminScheduledInvitation row (see
// api/src/modules/scheduling/scheduled-invitations.service.ts's
// ScheduledInvitationView) as a status line + pill. Shared by
// credentials-panel.js (the invitation just created/scheduled) and
// org-detail.js's "Scheduled invitations" card (recent history for the org).
// ---------------------------------------------------------------------------

const STATUS = {
  SCHEDULED: ['Scheduled', 'blue'],
  PROCESSING: ['Sending…', 'blue'],
  SENT: ['Sent', 'green'],
  FAILED: ['Failed', 'red'],
  CANCELLED: ['Cancelled', 'gray'],
};

function statusBadge(status) {
  const [label, tone] = STATUS[status] ?? [status, 'gray'];
  return badge(label, tone);
}

/** @param {{scheduledLabel: string, timezone: string, status: string, sentAt: string|null, lastError: string|null}} inv */
export function scheduledInvitationStatus(inv) {
  return el(
    'div',
    { class: 'scheduled-invite' },
    el(
      'p',
      { class: 'scheduled-invite__line' },
      'Invitation: ',
      inv.status === 'SENT' ? `Sent ${fmtDate(inv.sentAt)}` : `Scheduled for ${inv.scheduledLabel}`,
      ' ',
      statusBadge(inv.status),
    ),
    inv.status === 'FAILED' || inv.status === 'CANCELLED'
      ? el('p', { class: 'scheduled-invite__error' }, inv.lastError ?? 'No further detail recorded.')
      : null,
  );
}

/** A compact list for the org Overview card — newest first, same as the API already returns them. */
export function scheduledInvitationsPanel(rows) {
  return rows.length === 0
    ? el('p', { class: 'sidebar-note' }, 'No scheduled invitations for this organisation yet.')
    : el(
        'div',
        { class: 'scheduled-invite-list' },
        rows.map((r) =>
          el(
            'div',
            { class: 'scheduled-invite-row' },
            el('span', { class: 'scheduled-invite-row__email mono' }, r.email),
            scheduledInvitationStatus(r),
          ),
        ),
      );
}
